import { EventBus } from "../../../eventbus";
import { baseUrl } from "../../../config";
import { errorDispatch } from "../../../functions/errorDispatch";
import i18next from "../../../functions/i18next";

export default {
  data() {
    return {
      id: this.$options.name,
      optionsData: {},
    };
  },
  created() {
    EventBus.$on(`${this.id}-show`, (data) => {
      //show this overlay
      EventBus.$emit("openOverlayPage", data);

      if (data.optionsData) {
        this.optionsData = data.optionsData;
      } else {
        this.optionsData = {};
      }
    });

    EventBus.$on(`${this.id}-delete`, (data) => {
      if (data.id) {
        this.deleteCollection();
      }
    });
  },

  methods: {
    deleteCollection() {
      const formData = new FormData();

      formData.append("collection", this.optionsData.collection_id);

      this.$axios
        .post(`${baseUrl}/collectiondelete`, formData)
        .then((r) => {
          //update name
          EventBus.$emit("mobile-collections-update", {});

          //close overlay
          EventBus.$emit("closeOverlayPage", { id: this.id });

          //redirect to collections page
          this.$router.push(`/${this.$store.state.company}/collections`);
        })
        .catch((e) => {
          errorDispatch(i18next.t("error.delete_collection"));
        });
    },
  },
};
